import React from "react";
import { useField } from "../Form/useField";
import { TextField } from "../../components";
import _ from "lodash";

type Props = {
  label: string;
  disabled?: boolean;
  id: string;
  className?: string;
  name: string;
  required?: boolean;
  characterCounter?: boolean;
  inputProps?: any;
  destroyValueOnUnmount?: boolean;
  defaultValue?: string | null;
  type?: string;
  multiline?: boolean;
};

const FormTextField: React.FC<Props> = ({
  label,
  id,
  className,
  name,
  required,
  defaultValue,
  characterCounter = false,
  inputProps,
  destroyValueOnUnmount = false,
  type,
  multiline,
  disabled
}) => {
  const { value, onChange } = useField({
    name,
    required,
    destroyValueOnUnmount,
    defaultValue: _.isNil(defaultValue) ? "" : defaultValue,
    validate: value => {
      if (value.length > 0 && value.trim().length === 0) {
        return "invalid input";
      }
    }
  });

  return (
    <TextField
      disabled={disabled}
      required={required}
      multiline={multiline}
      characterCounter={characterCounter}
      inputProps={inputProps}
      className={className}
      id={id}
      type={type}
      label={label}
      onChange={onChange}
      value={value}
    />
  );
};

export default FormTextField;
